module.exports = __webpack_public_path__ + "images/92725e3f3712fe1ce510a8b0dbecb280.png";